var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"suspension"},[(_vm.btnFlag)?_c('div',{staticClass:"backtop",on:{"click":_vm.backtop}},[_c('i',{staticClass:"el-icon-caret-top"})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }